/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const PrivacyPolicyList = secureLocalStorage.getItem("policy");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="width_container">

            <h1 className="font-[600] text-[40px] my-[20px]">{t("Privacy Policy")}</h1>

            <div className="text-[14px] mt-[5px]" dangerouslySetInnerHTML={{ __html: PrivacyPolicyList }} />
        </div>
    )
}

export default PrivacyPolicy
/* jshint ignore:end */